// (c) 2023 384 (tm)

import { SBFileSystem } from './system';

export const file = {
    fs: SBFileSystem,
};
